export enum CalendarEventParticipantResponseType {
    none = 0,
    organizer = 1,
    tentativelyAccepted = 2,
    accepted = 3,
    declined = 4,
    notResponded = 5
}
export namespace CalendarEventParticipantResponseType{
    export function getName(value: CalendarEventParticipantResponseType): string {
        switch (value) {
            case CalendarEventParticipantResponseType.none:
                return "none";
            case CalendarEventParticipantResponseType.organizer:
                return "organizer";
            case CalendarEventParticipantResponseType.tentativelyAccepted:
                return "tentativelyAccepted";
            case CalendarEventParticipantResponseType.accepted:
                return "accepted";
            case CalendarEventParticipantResponseType.declined:
                return "declined";
            case CalendarEventParticipantResponseType.notResponded:
                return "notResponded";
            default:
                return "???";
        }
    }
}
